import { HttpClient,  HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable, map} from 'rxjs';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
}

@Injectable({
  providedIn: 'root'
})
export class ReportService {
  superAdminUrl = environment?.baseApiUrl + environment?.superAdminApiPath;

  constructor(private readonly http: HttpClient) { }

  fetchActiveProjectHandler(): Observable<any> {
    const url = `${this.superAdminUrl}fetchActiveProjectHandler${environment?.proxy}`;
    return this.http.get(url, httpOptions)
      .pipe(map((response: any) => response));
  }

  fetchActivityHandler(): Observable<any> {
    const url = `${this.superAdminUrl}fetchActivityHandler${environment?.proxy}`;
    return this.http.get(url, httpOptions)
      .pipe(map((response: any) => response));
  }

  createActivityHandler(request: any): Observable<any> {
    const url = `${this.superAdminUrl}createActivityHandler${environment?.proxy}`;
    return this.http.post(url, request, httpOptions)
      .pipe(map((response: any) => response));
  }

  updateActivityHandler(request: any, taskId: any): Observable<any> {
    const url = `${this.superAdminUrl}updateActivityHandler${environment?.proxy}?taskId=${taskId}`;
    return this.http.post(url, request, httpOptions)
      .pipe(map((response: any) => response));
  }

  deleteActivityHandler(request:any): Observable<any> {
    const url = `${this.superAdminUrl}dltActivityHandler${environment?.proxy}`;
    return this.http.post(url, request, httpOptions)
      .pipe(map((response: any) => response));
  } 
}
